<template>
    <div class='wheel_of_magic text-center'>
        <div v-if="ticket.ticket_is_lucky && (luckyWheelAmount > 0 || ticket.scenario.bonus)" class="">
            <div v-if="luckyWheelAmount > 0" class="pb-2">
                <h6 class="text-center pt-3">{{'winning' | lang}}</h6>
                <div class="w-100 d-flex align-items-baseline justify-content-center wheel">
                    <span v-for="(amount, itemIndex) in splittedAmount" :key="itemIndex" :class="{'separator' : (amount === '.' || amount === ',')}">
                        <img class="img-fluid" :src="`/fg/v2/games/wheel_of_magic/img/counters/active/${(amount === '.' ? 'dot' : (amount === ',' ? 'comma' : amount))}.png`">
                    </span>
                </div>
            </div>

            <div v-if="ticket.scenario.bonus" class="pb-2">
                <h6 class="text-center pt-3" >{{'bonus' | lang}}</h6>
                <div class="bonus w-100 d-flex align-items-baseline justify-content-center">
                    <span v-for="(amount, itemIndex) in splittedBonus" :key="itemIndex" :class="{'separator' : (amount === '.' || amount === ',')}">
                        <img class="img-fluid" :src="`/fg/v2/games/wheel_of_magic/img/counters/bonus_win/${(amount === '.' ? 'dot' : (amount === ',' ? 'comma' : amount))}.png`">
                    </span>
                </div>
            </div>

            <div v-if="ticket.scenario.multiplier">
                <h6 class="text-center pt-3" >{{'multiplier' | lang}}</h6>
                <div class="multiplier w-100 d-flex align-items-center justify-content-center">
                    <img class="img-fluid" :src="`/fg/v2/games/wheel_of_magic/img/${ticket.scenario.multiplier}x.png`">
                </div>
            </div>
        </div>
        <div v-else class = 'no-winnings d-flex align-items-center justify-content-center'>
            <h6>{{'noWinning' | lang}}</h6>
        </div>
    </div>
</template>

<script>
export default {
    props: ['ticket', 'gameName'],
    data() {
        return {
            luckyWheelAmount: 0
        }
    },
    methods: {
        detectLuckyWheelAmount() {
            for (const [key, symbol] of Object.entries(this.ticket.scenario.wheel_symbols)) {
                if (symbol.win) {
                    this.luckyWheelAmount = symbol.amount;

                    return;
                }
            }
        },
    },
    computed: {
        splittedAmount() {
            return String(this.luckyWheelAmount).split("");
        },
        splittedBonus() {
            if (!this.ticket.scenario.bonus) {
                return;
            }

            return String(this.ticket.scenario.bonus.luckies[0]).split("");
        }
    },
    mounted() {
        this.detectLuckyWheelAmount();
    }
}
</script>

<style>
    .wheel_of_magic .multiplier img {
        width: 50px;
    }
    .wheel_of_magic .wheel img, .wheel_of_magic .bonus img {
        width: 20px;
    }
    .wheel_of_magic .wheel .separator img, .wheel_of_magic .bonus .separator img {
        width: 13px;
    }
</style>